__turbopack_context__.v({
  "link": "SideNavigation-module__Pr1uxq__link",
  "list": "SideNavigation-module__Pr1uxq__list",
  "navigation": "SideNavigation-module__Pr1uxq__navigation",
});
